export { DepartmentTable } from './libs/department-table';
export { Department } from './libs/department-list';
export { DepartmentDetailComponent } from './libs/department-detail';
